import script from "./LoginAIO.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginAIO.vue?vue&type=script&setup=true&lang=js"

import "./LoginAIO.vue?vue&type=style&index=0&id=26b549a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26b549a1"]])

export default __exports__